import * as React from 'react';

import { PageContent } from '@/components/TailwindComponents/components/Page/PageContent';
import { PageHeader } from '@/components/TailwindComponents/components/Page/PageHeader';
import { cn } from '@/components/TailwindComponents/lib/utils';

interface MainPageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const MainPageLayout: React.FC<MainPageLayoutProps> = ({
  children,
  className,
}) => {
  const HeaderComponent = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === PageHeader,
  );
  const PageContentComponent = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === PageContent,
  );
  return (
    <div
      className={cn(
        'min-h-screen w-full h-full flex flex-col bg-white page-layout',
        className,
      )}
    >
      {HeaderComponent}
      {PageContentComponent || children}
    </div>
  );
};

export default MainPageLayout;
